// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xsmallOnConfined-superElipse-2910fb4a","strokeWidth":"super-ellipse-skins-xsmallOnConfined-strokeWidth-ec70d050"};